import React from 'react';

import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import { Link } from 'react-router-dom';
import reportPageEmptyState from 'styles/assets/png/reportPageEmptyState.png';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';
import { Button } from 'components/DesignSystem/Button';
import classes from 'components/widgets/ReportsHome/ReportsListTable/ReportsEmptyState.module.scss';

export const ReportsEmptyState = () => {
    return (
        <div className={classes.emptyStateWrapper}>
            <div className={classes.emptyState}>
                <img src={reportPageEmptyState} className={classes.reportPageEmptyState} alt={'No reports'} />
                <div data-testid={'empty-title'} className={classes.emptyStateTitle}>You don't have access to any existing Reports</div>
                <div className={classes.emptyStateSubTitle}>
                    Create your own report to start tracking project or portfolio performance with custom reports or
                    ready-made templates.
                </div>
                <div className={classes.buttonWrapper}>
                    <Button
                        component={Link}
                        startIcon={<MuiIcon icon={'add'} color={'inherit'} />}
                        data-testid={'create-report-btn'}
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD,
                            dashboardConfig.reporting.link,
                            reportingConfig.create.link,
                        )}
                    >
                        Create report
                    </Button>
                </div>
            </div>
        </div>
    );
};
